module.exports = __webpack_public_path__ + "static/media/amazon_big.27f3b57d.png";